import React, { Component } from 'react';
import { Link } from 'gatsby';
import { ACCOUNT_HUB_URL } from 'gatsby-env-variables';
import classnames from 'classnames';
import { get } from 'lodash';

import { ServicePageColors } from '../../components/Theme.jsx';
import profileLogo from '../../assets/profile_logo_white.svg';
import profileLogoGreen from '../../assets/profile-pensions-logo.svg';
import profileLogoEggPlant from '../../assets/profile-logo-eggplant.svg';

import './Navbar.scss';

const LIME_HEX = '#92DE63';
const LIGHT_GREY_HEX = '#CECCCE';

const WHITE = 'white';
const DARK = 'dark';
const LIGHT = 'light';
const LIGHT_COLORS = ['white', 'pale-piggy', 'grey', 'mint'];

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openedSubMenu: '',
      openedMobileMenu: false,
      scrollPosition: null,
      screenWidth: null,
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.setDomNode = this.setDomNode.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
    document.addEventListener('touchend', this.handleClickOutside, true);
    document.addEventListener('scroll', this.handleScroll, true);
    window.addEventListener('resize', this.handleResize, true);
    this.setState({ screenWidth: window.outerWidth });
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
    document.removeEventListener('touchend', this.handleClickOutside, true);
    document.removeEventListener('scroll', this.handleScroll, true);
    window.removeEventListener('resize', this.handleResize, true);
  }

  setDomNode(node) {
    this.domNode = node;
  }

  handleClickOutside(e) {
    if (!this.domNode || !this.domNode.contains(e.target)) {
      this.setState({ openedMobileMenu: false });
      this.openSubMenu('');
    }
  }

  handleScroll(e) {
    this.setState({ scrollPosition: window.scrollY });
  }

  handleResize(e) {
    this.setState({ screenWidth: window.outerWidth });
  }

  openSubMenu(name) {
    const menuName = this.isSubMenuOpened(name) ? '' : name;
    this.setState({ openedSubMenu: menuName });
  }

  isSubMenuOpened(name) {
    return this.state.openedSubMenu === name;
  }

  toggleMobileMenu() {
    const { openedMobileMenu } = this.state;
    this.setState({ openedMobileMenu: !openedMobileMenu });
  }

  getTheme() {
    const { scrollPosition } = this.state;
    const { navigationColor, colourChangeScrollThreshold, sectionData } = this.props;
    const theme = ServicePageColors[get(sectionData, 'colour')] || ServicePageColors[navigationColor] || ServicePageColors.white;
    if (!scrollPosition || scrollPosition < colourChangeScrollThreshold) {
      return {
        backgroundColor: theme.backgroundColor,
        headingColor: theme.headingColor,
        contentColor: theme.contentColor,
      };
    }
    return {
      backgroundColor: ServicePageColors[WHITE].backgroundColor,
      headingColor: ServicePageColors[WHITE].headingColor,
      contentColor: ServicePageColors[WHITE].contentColor,
    };
  }

  getMenuColorType() {
    const { scrollPosition } = this.state;
    const { navigationColor, colourChangeScrollThreshold, sectionData } = this.props;

    const customNavigationColor = get(sectionData, 'colour');
    const color = customNavigationColor && customNavigationColor !== 'inherit' ? customNavigationColor : navigationColor;
    if(color === WHITE) {
      return DARK;
    }
    if (!scrollPosition || scrollPosition < colourChangeScrollThreshold) {
      return LIGHT_COLORS.includes(color) ? LIGHT : DARK;
    }
    return DARK;
  }

  render() {
    const { openedSubMenu, openedMobileMenu } = this.state;
    const { subNav = {}, sectionData = {} } = this.props;
    const { displaySubNav, subNavLink, subNavLinkText, subNavTheme } = subNav;

    const topLevelLinks = get(sectionData, 'topLevelLinks');

    const theme = this.getTheme();
    const menuColorType = this.getMenuColorType();

    return (
      <div className={`navigation-section ${theme.backgroundColor} ${openedMobileMenu ? 'mobile-open' : ''}`} id="nav-bar">
        <div className={`navigation-section-wrapper ${theme.backgroundColor}`} ref={this.setDomNode}>
          <div className="navigation-menu-heading">
            <Link className="navigation-menu-logo" to="/" rel="noreferrer noopener">
              <img src={menuColorType === 'dark' ? profileLogoEggPlant : profileLogoGreen} alt="Profile Pensions" />
            </Link>
            <div className={`navigation-mobile-wrapper ${theme.headingColor}`}>
              <a href={`${ACCOUNT_HUB_URL}/signup`} className={`navigation-menu-mobile-cta-link ${theme.backgroundColor}`} rel="noreferrer noopener">Get started</a>
              <button className="navigation-mobile-menu-button" onClick={this.toggleMobileMenu}>
                <h4 className={`navigation-mobile-menu-button-title ${theme.headingColor}`}>Menu</h4>
                {openedMobileMenu ? (
                  <svg width="13px" height="13px" viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                      <g transform="translate(-330.000000, -59.000000)" stroke={menuColorType === 'dark' ? '#FFFFFF' : '#125A42'} strokeWidth="2">
                        <g transform="translate(331.000000, 60.000000)">
                          <path d="M0.660264204,17.0926655 L16.9237202,0.829209516" id="Line"></path>
                          <path d="M16.9237202,17.0926655 L0.660264204,0.829209516" id="Line"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg width="14px" height="11px" viewBox="0 0 26 19" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                      <g transform="translate(1.000000, 0.000000)" stroke={menuColorType === 'dark' ? '#FFFFFF' : '#125A42'} strokeWidth="2">
                        <g>
                          <path d="M0.5,1.5 L23.5,1.5" id="Line"></path>
                          <path d="M0.5,9.5 L23.5,9.5" id="Line"></path>
                          <path d="M0.5,17.5 L23.5,17.5" id="Line"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                )}
              </button>
            </div>
          </div>
          <nav className={`navigation-menu-items ${theme.headingColor}`}>
            <ul>
              {topLevelLinks.map((topLevelNavItem) => {
                const { __typename, url, name, displayText, subLinks = [] } = topLevelNavItem;

                if (__typename === 'ContentfulNavbarTopLevelLink') {
                  return (
                    <li key={name}>
                      <span className="navigation-menu-item-nested" onClick={() => this.openSubMenu(name)}>
                        <p>{name}</p>
                        <svg className="angle" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d={openedSubMenu === name ? 'M6.3424 0.686285L0.685547 6.34314H11.9993L6.3424 0.686285Z' : 'M6.34315 6.31371L12 0.65686H0.686292L6.34315 6.31371Z'}
                            fill={LIGHT_GREY_HEX}
                          />
                        </svg>
                      </span>
                      {
                        openedSubMenu === name && (
                          <div className="navigation-menu-subitems">
                            <div className="navigation-menu-subitems-triangle"></div>
                            {subLinks.map((subLinkItem) => {
                              return (
                                <Link
                                  key={subLinkItem.name}
                                  className="navigation-menu-subitem"
                                  to={subLinkItem.url}
                                  rel="noreferrer noopener"
                                >
                                  {subLinkItem.displayText}
                                </Link>
                              );
                            })}
                          </div>
                        )
                      }
                    </li>
                  );
                }

                if (__typename === 'ContentfulLink') {
                  return <li key={name}><a className="navigation-menu-item" href={url} rel="noreferrer noopener">{displayText}</a></li>;
                }

                return null;
              })}
            </ul>
          </nav>
          <div className={`navigation-menu-cta ${theme.headingColor}`}>
            <a className="navigation-menu-login" href="https://account.profilepensions.co.uk/login" rel="noreferrer noopener">Log in</a>
            <a href={`${ACCOUNT_HUB_URL}/signup`} className={`navigation-menu-cta-link ${theme.backgroundColor}`} rel="noreferrer noopener">Get started</a>
          </div>
        </div>
        {
          displaySubNav && (
            <div
              className={
                classnames(
                  "blog-navigation-section",
                  {
                    "blog-navigation-section-egg-plant": subNavTheme === "white",
                    "blog-navigation-section-forest": subNavTheme === "forest",
                    "blog-navigation-section-midnight": subNavTheme === "midnight",
                  },
                )
              }>
              <div className="blog-navigation-section-wrapper">
                <span>
                  <p>←</p>
                  <Link to={subNavLink} rel="noreferrer noopener">{subNavLinkText}</Link>
                </span>
              </div>
            </div>
          )
        }
      </div>
    );
  }
};

Navbar.defaultProps = {
  colourChangeScrollThreshold: 500,
};

export default Navbar;
